import { creators } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function CreatorsSection() {
  return (
    <section id="creators" className="w-full bg-background-50 py-14 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="优质创作者推荐"
          title="找到风格对味的作者，持续追更不吃力"
          desc="不同创作者擅长不同方向，从家常料理到硬核拆解，关注一个对味的作者，就能稳定刷到同类优质内容。"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {creators.map((creator) => (
            <article
              key={creator.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center gap-4">
                <div className="h-16 w-16 shrink-0 overflow-hidden rounded-full border-2 border-primary-200">
                  <img
                    src={creator.avatar}
                    alt={`${creator.name} 创作者头像`}
                    title={`${creator.name} · ${creator.field}创作者`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0">
                  <h3 className="truncate font-heading text-base font-bold text-foreground-950">{creator.name}</h3>
                  <span className="mt-1 inline-block rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-900">
                    {creator.field}创作者
                  </span>
                </div>
              </div>

              <p className="mt-4 line-clamp-2 text-sm leading-relaxed text-foreground-600">{creator.bio}</p>

              <div className="mt-4 grid grid-cols-2 border-t border-background-200 pt-4">
                <div>
                  <p className="font-heading text-base font-bold text-foreground-950">{creator.followers}</p>
                  <p className="mt-0.5 text-xs text-foreground-500">关注者</p>
                </div>
                <div>
                  <p className="font-heading text-base font-bold text-foreground-950">{creator.works}</p>
                  <p className="mt-0.5 text-xs text-foreground-500">作品数</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}